Object.defineProperty(exports, "__esModule", {value: true});

exports.default = {
	Enum: {}
};


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/hxClasses_stub.js
// module id = 1
// module chunks = 0